/* eslint-disable no-undef */
import axios from 'axios'
import store from '@/store'
import { getToken, removeAll } from '@/utils/localstorage' // 存储本数据

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.timeout = 60000
const service = axios.create({
  baseURL: process.env.BASE_API_ZCM,
  withCredentials: true, // 允许携带cookie
})

service.interceptors.request.use(
  config => {
    let token
    if (process.env.NODE_ENV !== 'development') {
      token = getToken('webToken')
      if (token) {
        config.headers['webtoken'] = token
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      }
    } else {
      config.headers['webtoken'] = getToken('webToken')
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    config => {
      config.data = JSON.stringify(config.data)
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.flag === 'error') {
      if (res.msg === '请登陆') {
        store.dispatch('FedLogOut').then(() => {
          if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'testing') {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          }
        })
        return Promise.reject('error')
      } else {
        return res
      }
    }
    return res
  },
  error => {
    console.log('error', error.message)
    let message = ''
    if (error.response) {
      message = error.response.data.message
    }
    if (error.message.includes('timeout')) {
      let timeOut = {
        response: {
          data: {
            message: '请求超时!',
          },
        },
      }
      return Promise.reject(timeOut)
    }
    if (message === 'Login check error') {
      // eslint-disable-next-line no-console
      console.log(message)
      removeAll()
      location.href = '/login'
    }
    return Promise.reject(error)
  },
)

export default service.request



// WEBPACK FOOTER //
// ./src/utils/request_zcm.js